import React from "react";

import { getLocalStorageCountry, useTranslation } from "utils";

import { COUNTRY_CODE, TAX_MECHANISM, TAX_RATES } from "consts";

import { Col, Form, Input, InputMasked, LinkMoreInfo, Radio, Row } from "components";

// This could be extended to allow for other country ibans as well
const ibanMasks = {
  DE: "aa00 0000 0000 0000 0000 00",
  PL: "aa00 0000 0000 0000 0000 0000 0000",
};

export const BankInformation = ({ details, setToggleModalTaxRate, toggleModalTaxRate }) => {
  const { t } = useTranslation(["points"]);
  const country = getLocalStorageCountry();
  const taxRatesExist = country === null || Object.keys(TAX_RATES).includes(country);

  // Following docs of https://www.npmjs.com/package/antd-mask-input
  // Always memoize dynamic masks
  const mask = React.useMemo(
    () => [
      {
        mask: ibanMasks.DE,
        lazy: false,
      },
      {
        mask: ibanMasks.PL,
        lazy: false,
      },
    ],
    []
  );

  return (
    <>
      <Row>
        <Col sm={24} md={9}>
          <Input name="accountHolder" label={t("accountHolder")} rules={[{ required: true }]} initialValue={details.accountHolder} />
        </Col>
        <Col sm={24} md={15}>
          <InputMasked
            name="iban"
            label={t("iban")}
            rules={[{ required: true }]}
            initialValue={details.iban ? details.iban.trim() : details.iban}
            mask={mask}
            maskOptions={{
              dispatch: (_, dynamicMasked) => dynamicMasked.compiledMasks[dynamicMasked.unmaskedValue.startsWith("PL") ? 1 : 0],
            }}
            placeholder="DE11 1111 1111 1111 1111 11"
          />
        </Col>
      </Row>
      <Row className="margin-bottom-250">
        <Col sm={24} md={15}>
          <Input name="taxNumber" label={t("taxNumber")} rules={[{ required: taxRatesExist }]} initialValue={details.taxNumber} />
        </Col>
        {taxRatesExist && (
          <Col sm={24} md={9}>
            <Row>
              <Col>
                <LinkMoreInfo dataTestId="modal-tax-rate" onClick={() => setToggleModalTaxRate(!toggleModalTaxRate)}>
                  {t("taxRate")}
                </LinkMoreInfo>
              </Col>
            </Row>
            <Form.Item name="taxRate" rules={[{ required: true }]} initialValue={parseFloat(details?.taxRate ?? 0)}>
              <Radio.Group>
                <Row>
                  <Col>
                    {TAX_RATES[country ?? COUNTRY_CODE.GERMANY].map((taxRate, index) => (
                      <Radio data-testid={`radio-button-tax-rate-${taxRate.value}`} value={taxRate.value} key={index}>
                        {taxRate.value}% {taxRate.mechanism === TAX_MECHANISM.reverseCharge && t("reverseCharge")}
                      </Radio>
                    ))}
                  </Col>
                </Row>
              </Radio.Group>
            </Form.Item>
          </Col>
        )}
      </Row>
    </>
  );
};
